/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import {
  getUserByToken,
  login,
} from "../../components/layout/auth/core/_requests";
import { useAuth } from "../../components/layout/auth/core/Auth";
import { useIntl } from "react-intl";
import phoneFormat from "../../helpers/phoneFormat";
import onlyNumber from "../../helpers/onlyNumber";
import { setHeaderToken } from "../../api";

const loginSchema = Yup.object().shape({
  phone: Yup.string()
    .length(17, "Bu telefon raqam emas")
    .required("Telefon raqam majburiy"),
  password: Yup.string()
    .min(8, "Minimal 8 ta belgi")
    .matches(/[0-9]/, "Kamida bitta raqam bo‘lishi majburiy")
    .matches(/[a-z]/, "Kamida bitta kichkina harf bo‘lishi majburiy")
    .required("Parol majburiy"),
});

const initialValues = {
  phone: "+998 91-123-45-67",
  password: "12345678a",
};

export function Login() {
  const [loading, setLoading] = useState(false);
  const { saveAuth, setCurrentUser } = useAuth();
  const intl = useIntl();

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {
        const { data: auth } = await login(
          onlyNumber(values.phone),
          values.password
        );
        saveAuth(auth);
        setHeaderToken(auth.access);
        const { data: user } = await getUserByToken();
        setCurrentUser(user);
      } catch (error) {
        console.error(error);
        saveAuth(undefined);
        setStatus("Telefon raqam yoki parol xato");
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <form
      className="form w-100"
      onSubmit={formik.handleSubmit}
      noValidate
      id="kt_login_signin_form"
    >
      {/* begin::Heading */}
      <div className="text-center mb-11">
        <h1 className="text-dark fw-bolder mb-3">
          {intl.formatMessage({ id: "Kirish" })}
        </h1>
        <div className="text-gray-500 fw-semibold fs-6">
          {intl.formatMessage({
            id: "Akauntga kirish uchun ma’lumotlarni to’ldiring",
          })}
        </div>
      </div>
      {/* begin::Heading */}

      {/* begin::Form group */}
      <div className="fv-row mb-8">
        <label className="form-label fs-6 fw-bolder text-dark">
          {intl.formatMessage({ id: "Telefon raqam" })}
        </label>
        <input
          placeholder="Telefon raqamingiz"
          {...formik.getFieldProps("phone")}
          onChange={(e) =>
            formik.setFieldValue("phone", phoneFormat(e.target.value))
          }
          className={clsx(
            "form-control bg-transparent",
            { "is-invalid": formik.touched.phone && formik.errors.phone },
            {
              "is-valid": formik.touched.phone && !formik.errors.phone,
            }
          )}
          type="text"
          name="phone"
          autoComplete="off"
        />
        {formik.touched.phone && formik.errors.phone && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.phone}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className="fv-row mb-3">
        <div className="mb-1">
          <label className="form-label fw-bolder text-dark fs-6 mb-0">
            {intl.formatMessage({ id: "Parol" })}
          </label>
          <input
            placeholder="Parolingizni kiriting"
            type="password"
            autoComplete="off"
            {...formik.getFieldProps("password")}
            className={clsx(
              "form-control bg-transparent",
              {
                "is-invalid": formik.touched.password && formik.errors.password,
              },
              {
                "is-valid": formik.touched.password && !formik.errors.password,
              }
            )}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                <span role="alert">{formik.errors.password}</span>
              </div>
            </div>
          ) : (
            <div className="text-muted mt-1">
              {intl.formatMessage({
                id: "8 yoki undan ko'p belgilar bilan foydalaning, harflar, raqamlar va belgilar aralashmasi bilan.",
              })}
            </div>
          )}
        </div>
      </div>

      {formik.status && (
        <div className="text-danger text-center fw-semibold fs-6">
          {intl.formatMessage({ id: formik.status })}
        </div>
      )}

      {/* end::Form group */}

      {/* begin::Wrapper */}
      <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
        <div />

        {/* begin::Link */}
        <Link to={`/auth/reset-password/phone-number`} className="link-primary">
          {intl.formatMessage({ id: "Parolni tiklash" })}
        </Link>
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className="d-grid mb-10">
        <button
          type="submit"
          id="kt_sign_in_submit"
          className="btn btn-primary"
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && (
            <span className="indicator-label">
              {intl.formatMessage({ id: "Kirish" })}
            </span>
          )}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              {intl.formatMessage({ id: "Iltimos kuting..." })}
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      <div className="text-gray-500 text-center fw-semibold fs-6">
        {intl.formatMessage({ id: "Akkauntingiz yo'qmi?" })}{" "}
        <Link to={`/auth/register/info`} className="link-primary">
          {intl.formatMessage({ id: "Ro'yhatdan o'tish" })}
        </Link>
      </div>
    </form>
  );
}
